export default `
	guid
	created_at
	updated_at
	title
	body
	kind
	status
`;
